import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { CheckCircle, Star, Flame, AlertTriangle } from 'lucide-react';
import ShopifyBuyButton from '@/components/ShopifyBuyButton';
import LaunchCountdown from '@/components/LaunchCountdown';
import InteractiveProductImageMaxed from './InteractiveProductImageMaxed';
import IngredientsOverviewMaxed from './IngredientsOverviewMaxed';
import { useLaunchStatus } from '@/hooks/useLaunchStatus';

const SalesSectionMaxed = () => {
  const isLaunched = useLaunchStatus();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
      <Card className="bg-card border border-border shadow-lg overflow-hidden">
        <CardHeader>
          <div className="flex items-center gap-2 mb-2">
            <Badge variant="secondary" className="bg-primary text-primary-foreground">
              <Flame className="w-3 h-3 mr-1" />
              MAXED
            </Badge>
            <Badge variant="outline" className="border-primary text-primary">
              <Star className="w-3 h-3 mr-1" />
              350mg koffein
            </Badge>
          </div>
          <CardTitle className="text-4xl font-bold mb-2 text-foreground font-orbit">
            Peveo Maxed 700g
          </CardTitle>
          <div className="flex items-baseline gap-3 mb-2">
            <span className="text-5xl font-bold text-primary">499,-</span>
            <span className="text-sm text-muted-foreground">kr (inkl. mva)</span>
          </div>
          <div className="mb-4">
            <Badge variant="outline" className="border-green-600 text-green-600 bg-green-50">
              🚚 Gratis frakt over 800 kr
            </Badge>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-xl leading-snug text-foreground font-medium">
            Ekstrem pre-workout for de som vil ha maksimal intensitet. 350mg koffein og beta-alanine for ultimate energi og utholdenhet. Denne er laget for å være Norges høyest doserte PWO, og ble starten på vår suksess i 2023.
          </p>

          <div className="bg-primary/10 p-4 rounded-lg border border-primary/20">
            <div className="flex items-center gap-2 mb-2">
              <Star className="text-primary w-5 h-5" />
              <p className="text-primary font-semibold">Bland med PWO-Competition for tilpasset koffein</p>
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed">
              350mg koffein er mye for mange. Siden Maxed og <span className="text-primary font-medium">Competition (koffeinfri)</span> har nesten identiske formuleringer,
              kan du enkelt blande dem for ønsket koffeinnivå. F.eks. 50/50 gir deg <span className="text-foreground font-semibold">175mg koffein</span> med full dose av alle andre ingredienser.
            </p>
          </div>

          <div className="bg-amber-50 p-4 rounded-lg border border-amber-200">
            <div className="flex items-center gap-2 mb-2">
              <AlertTriangle className="text-amber-600 w-5 h-5" />
              <p className="text-amber-700 font-semibold">Advarsel: Høyt koffeininnhold</p>
            </div>
            <p className="text-amber-600 text-sm">
              Ikke overskrid anbefalt daglig dose. Ikke anbefalt for personer under 18 år, gravide eller ammende.
            </p>
          </div>

          <div className="bg-muted p-4 rounded-lg border border-border">
            <div className="flex items-center justify-center gap-2 mb-2">
              <CheckCircle className="text-green-600 w-5 h-5" />
              <p className="text-foreground font-semibold">På lager - levering 1-5 dager</p>
            </div>
            <p className="text-muted-foreground text-center text-sm">
              Tar leveringen lengre? Kontakt oss og få en gratis shaker ved neste bestilling
            </p>
          </div>

          <div className="pt-2">
            {isLaunched ? (
              <ShopifyBuyButton
                productId="9440709116135"
                componentId="product-component-sales-preworkout-maxed"
                domain="6pjebd-jw.myshopify.com"
                storefrontAccessToken="24c563b5bb4fa1b2d3b84fcb8e32090c"
                className="w-full"
              />
            ) : (
              <LaunchCountdown />
            )}
          </div>

          <div className="pt-4">
            <IngredientsOverviewMaxed />
          </div>
        </CardContent>
      </Card>

      <InteractiveProductImageMaxed />
    </div>
  );
};

export default SalesSectionMaxed;
